/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["span.incorrect[_ngcontent-%COMP%], span.partial[_ngcontent-%COMP%]{background:red;color:#fff;padding:0 6px;margin:0 2px}span.missing[_ngcontent-%COMP%]::after{content:\"...\";bottom:31px;color:#fff;background-color:red;padding:0 12px;margin:0 2px}"];
export { styles as styles };
